export default __webpack_public_path__ + "static/media/CSIO_green_logo_2.dd7f3008.png";